var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.noneView)?_c('div',{staticClass:"sticky-bottom bg-white",staticStyle:{"z-index":"5"},attrs:{"id":"sticky-bottom"}},[_c('StickyMenu')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }